<template>
  <!-- 积分兑换 -->
  <div class="IA_pointsExchange">
    <van-nav-bar :title="'我能兑换'"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 right-text="我的订单"
                 @click-right="gotoMyOrder"
                 :fixed="true" />
    <div class="content">
      <van-search v-model="searchTxt"
                  shape="round"
                  placeholder="请输入搜索关键词"
                  @input="onSearch" />
      <div class="goods_list">
        <van-grid :column-num="2"
                  :gutter="10">
          <van-grid-item v-for="(item,idx) in goodsList"
                         :key="idx"
                         @click="gotoDetail(item)">
            <template #icon>
              <van-image :src="item.pt_bg_url?item.pt_bg_url:require('@assets/img/loading-error.png')"
                         :class="item.balance <= 0?'sold_out_img':''"
                         fit="fill"
                         :width="'100%'"
                         height="150">
              </van-image>
              <van-button v-if="item.balance <= 0"
                          round
                          class="sold_out_btn"
                          size="small"
                          type="info">无库存</van-button>
            </template>
            <template #text>
              <div class="goods_title">
                <!-- <van-tag color="#fd0088">甄选</van-tag> -->
                <span class="depict">{{item.ptname_fullname}}</span>
              </div>
              <div class="jiage">
                <div class="ji_left">
                  <span class="txt">单价：</span>
                  {{item.ptcredit}}
                  <span class="txt">积分</span>
                </div>
                <div class="ji_right">
                  <span class="txt">剩：</span>
                  {{item.balance}}
                  <span class="txt">{{item.ptunit}}</span>
                </div>
              </div>
            </template>
          </van-grid-item>
        </van-grid>
      </div>
    </div>
  </div>
</template>

<script>
import { getCreditProductList } from '@api/integral.js'
export default {
  data () {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    return {
      userInfo,
      searchTxt: '',
      initgoods: [],
      goodsList: []
    }
  },
  created () {
    this.getCreditProductListData()
  },
  methods: {
    onSearch () {
      if (this.searchTxt)
      {
        this.goodsList = this.initgoods.filter(
          item =>
            item.ptname_fullname.indexOf(this.searchTxt) > -1
        )
      } else
      {
        this.goodsList = this.initgoods
      }
    },
    // 获取待兑换的商品信息
    getCreditProductListData () {
      getCreditProductList({
        username: this.userInfo.username
      }).then(res => {
        this.initgoods = JSON.parse(JSON.stringify(res.data))
        this.goodsList = res.data
      })
    },
    // 去商品详情
    gotoDetail (item) {
      this.$router.push({ path: '/goodsDetails', query: { from: this.$route.query.from, goodsId: item.autoid } })
    },
    // 我的订单
    gotoMyOrder () {
      this.$router.push({
        path: '/myOrders',
        query: { from: this.$route.query.from }
      })
    },
    // 返回
    onClickLeft () {
      if (this.$route.query.from == 'home')
      {
        this.$router.push('/home')
      } else
      {
        this.$router.push('/personCen')
      }
    },
  }

}
</script>

<style lang="less" scoped>
.IA_pointsExchange {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    /deep/.van-nav-bar__right {
      font-size: 28px;
      .van-nav-bar__text {
        color: #fff;
      }
    }
  }
  .content {
    // overflow: auto;
    margin-top: 1.22667rem;
    height: calc(100% - 92px);
    .van-search {
      height: 112px;
    }
    .goods_list {
      margin-top: 20px;
      height: calc(100% - 132px);
      overflow-y: auto;
      .van-grid {
        margin-bottom: 20px;
        .van-grid-item {
          /deep/.van-grid-item__content {
            padding: 20px;
            border-radius: 14px;
            align-items: flex-start;
            .van-grid-item__icon-wrapper {
              flex: 1;
              .sold_out_img {
                opacity: 0.3;
              }
              .sold_out_btn {
                width: 140px;
                height: 50px;
                line-height: 50px;
                padding: 0 30px;
                position: absolute;
                top: 125px;
                left: calc(50% - 70px);
                border: none; /* 无边框 */
                color: #ffffff;
                opacity: 0.5;
                background: #111111;
                font-size: 24px;
              }
            }
            .goods_title {
              font-size: 28px;
              line-height: 1.5;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              text-overflow: ellipsis;
              .depict {
                font-size: 28px;
              }
            }
            .jiage {
              width: 100%;
              font-size: 32px;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              .ji_left {
                color: #fd0088;
                .txt {
                  font-size: 20px;
                }
              }
              .ji_right {
                color: #ff976a;
                .txt {
                  font-size: 20px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>